<template>
    <div class="userInfo">
        <el-dialog title="用户信息" :visible.sync="isShow">
            <div class="headBox">
                <img :src="userInfo.logourl" class="logo" alt="">
                <p class="name">{{userInfo.customername}}<img v-if="userInfo.sex==1||userInfo.sex==2" :src="userInfo.sex==1?nan:nv" alt=""></p>
            </div>
            <div class="info_box">
                <p>
                    <span><label>真实姓名：</label>{{userInfo.name}}</span>
                    <span><label>生日：</label>{{userInfo.birth}}</span>
                </p>
                <p>
                    <span><label>手机号码：</label>{{userInfo.mobileno}}</span>
                    <span><label>邮箱：</label>{{userInfo.email}}</span>
                </p>
            </div>
            <div class="info_box info_bottom">
                <!--<p><span><label>来源：</label>{{userInfo.customername}}</span></p>-->
                <p><span><label>创建时间：</label>{{userInfo.datetime}}</span></p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getLiveEventUserInfo} from 'api/vliveV2Api'
    import {mapActions} from 'vuex'
    export default {
        name: "userInfo",
        data(){
            return{
                nv:require('@/common/images/vliveV2/nv.png'),
                nan:require('@/common/images/vliveV2/nan.png'),
                isShow:false,
                userInfo:{},
            }
        },
        methods:{
            open(id){
                this.isShow=true;
                this.setLoading(true);
                let param={
                    innerid:id
                };
                getLiveEventUserInfo({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.userInfo=data.data
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
            ])
        }
    }
</script>

<style lang="scss">
    .userInfo{
        .el-dialog {
            width: 600px;
        }
        .headBox{
            display: flex;
            align-items: center;
            .logo{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: #eee;
                display: inline-block;
                margin-right: 10px;
            }
            .name{
                display: flex;
                align-items: center;
                img{
                    width: 8px;
                    height: 13px;
                    margin-left: 6px;
                }
            }
        }
        .info_box{
            padding-bottom: 20px;
            border-bottom: 1px solid #DCDFE6;
            p{
                margin-top: 20px;
                display: flex;
                span{
                    flex: 1;
                    label{
                        color: #666;
                    }
                }
            }
        }
        .info_bottom{
            padding-bottom: 10px;
            border-bottom: none;
        }
    }
</style>
